import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="forms--auto-submit"
//
// Submits the host form via requestSubmit() so the form's method (GET, PATCH,
// POST, …) and Turbo behavior are honored. Use for inline auto-saving inputs
// like a status dropdown that should PATCH the resource on change.
export default class extends Controller {
  submit() {
    this.element.requestSubmit();
  }
}
